module.exports = __webpack_public_path__ + "img/ku.62442644.png";